export * from './home'



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/home/index.ts